import type { UseBalanceWithPointsReturn } from "@apac/components/checkout";
import type { Product } from "@b2bportal/purchase-api";
import { useCheckoutStateSelector } from "@checkout/context";
import { useMaxOverpay } from "@hsbc/portal";
import { useRewardsSectionConversion } from "@hsbc/rewards";
import { getRewardsAmountToApplyInCash } from "@hsbc/rewards";
import {
  productTotalSelectorByProduct,
  roundToTwoDecimal,
} from "@hsbc/utilities";
import { useBalanceWithTravelCredits } from "@hsbc/wallet";

export const useBalanceWithPoints = (
  product?: Product
): UseBalanceWithPointsReturn => {
  const { remaingCashBalance: priceAfterCredit } =
    useBalanceWithTravelCredits(product);

  const { fiat } = useCheckoutStateSelector(
    productTotalSelectorByProduct(product)
  );

  const { isLoading } = useRewardsSectionConversion();

  const rewardsPayInCash = useCheckoutStateSelector(
    getRewardsAmountToApplyInCash
  );

  const maxOverpay = useMaxOverpay();

  const remainingBalance = {
    ...fiat,
    value: (() => {
      const value = roundToTwoDecimal(
        priceAfterCredit - (rewardsPayInCash?.value ?? 0)
      );
      if (value < 0 && maxOverpay != null && Math.abs(value) <= maxOverpay) {
        return 0;
      }
      return value;
    })(),
  };

  // This is simply read from state, no api involved
  return { remainingBalance, isConversionLoading: isLoading };
};
